import FastSax from 'fast-sax';
import axios from 'axios';

export const editorService = {
    getXliff,
	sendXliff,
	parseXliff,
	regeneraXliff,
	regeneraXliffPomise,
	matchSubstituition,
	searchRepetitions,
	spellCheck,
	parseSpellCheckResp,
	addEditorPoi,
	getEditorPois,
	deleteEditorPoi,
	calculaProgres,
	comprovaTags,
	setDistance,
	getGlossary,
	parseGlossary,
	recomptaParaules,
	updateWordCount
};

function getXliff(oauthToken, id) {
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/document/"+id+"/content/", {params: {}});
}

function sendXliff(id, xliff) {
	let config = {
		headers: {
//		  'Content-type': "multipart/form-data",
		  'Content-type': "application/x-www-form-urlencoded",
		  'Accept': "application/json"
		},
		params: {
		}
	}
	
	let formData = new FormData();
	formData.append('document', new File([xliff], "traduit.xlf", {type: "text/plain"}));
	
	return axios.put(process.env.REACT_APP_serverURL+"/documents-0.0.1/document/"+id+"/content/", formData, config);
}

function addEditorPoi(order_id, name, description, iTu, iSeg){
	let headers = {
		headers: {
		  'Content-Type': 'application/json;charset=UTF-8'
		},
		params: {
		}
	}
	let body = { 'name': name, 'description': description, 'orderId': order_id, 'indexTu': iTu, 'indexSeg': iSeg};
//	console.log("addEditorPoi: "+JSON.stringify(body));
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/editorPoi/", body, headers);
}

function getEditorPois(orderId){
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/editorPoi/order/"+orderId, {params: {}});
}

function deleteEditorPoi(id){
//	console.log("deleteEditorPoi("+id+")");
	return axios.delete(process.env.REACT_APP_serverURL+"/documents-0.0.1/editorPoi/"+id, {params: {}});
}

function parseXliff(xliff){
	var parser = new FastSax();

	var stackElements=[];
	var TUs = new Array;
	var inSegment=false;
	var segType="src";
	var newSegment=false;
	var inAltTrans=false;
	var mid=0;
	var state="new";
	
	var tags;
	var tagIds=[];
	var currentSegment;
	var currentSegmentList;
	var currentTag;
	var currentTU;
	var matchQuality=0;
	
	function TU(idTu){
		this.idTu=idTu
		this.segments=new Array();
	};
	
	function Segment(){
		this.text="";
		this.tags=new Array();
		this.trimI="";
	};
	
	function Tag(name, type, id, position, order, code){
		this.name = name;
		this.type = type;
		this.id = id;
		this.position = position;
		this.order = order;
		this.code = code;
	}
	
	function decodeHtmlEntities(text){
		return text.replace('&amp;', '&').replace('&lt;','<').replace('&gt;','>');
	}
	
	function trimInicial(segment){
		if(segment.tags.length===0){
			let regex = new RegExp('^([ \f\n\r\t\v\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+)');
			let espaisI = regex.exec(segment.text);
			if(espaisI!=null){
//				console.log("trimInicial [org]: ["+segment.text+"]:");
				segment.trimI=espaisI[1];
				segment.text=segment.text.replace(regex, "");
//				console.log("trimI: ["+segment.trimI+"]:");
			}
		}
	}
	
	parser.onElementStart = function(elementName, getAttributes) {
//		console.log("onElementStart "+elementName);
		const attributes = getAttributes();
		switch(elementName){
			case "trans-unit":	currentTU = new TU(attributes["id"]);
																		break;
			case "mrk":			inSegment=true;
								newSegment=true;
								currentSegment = new Segment();
								mid=attributes["mid"];
								state = typeof(attributes["state"]) != "undefined" ? attributes["state"] : "new";
																		break;
			case "seg-source":	segType="src";
																		break;
			case "target":		if(inAltTrans){
									inSegment=true;
									newSegment=true;
									currentSegment = new Segment();
								}else{
									segType="trg";
								}
																		break;
			case "source":		if(inAltTrans){
									inSegment=true;
									newSegment=true;
									currentSegment = new Segment();
								}
			
																		break;
			case "alt-trans":	segType=attributes["origin"];
								mid=attributes["mid"];
								inAltTrans=true;
								if(typeof attributes["match-quality"] !== "undefined"){
									matchQuality=attributes["match-quality"];
								}
																		break;
			case "g":			if(inSegment){
									currentSegment.tags.push(new Tag(elementName, "OPEN", attributes["id"], currentSegment.text.length, currentSegment.tags.length, currentSegment.tags.length));
								}
								tagIds.push(attributes["id"]);
																		break;
			default:
				if(inSegment){
					currentSegment.tags.push(new Tag(elementName, "ALONE", attributes["id"], currentSegment.text.length, currentSegment.tags.length, currentSegment.tags.length));
				}
		}
		stackElements.push(elementName);
	};
	
	parser.onElementEnd = function(elementName) {
//		console.log("stackElements.pop("+stackElements.pop()+")");
//		console.log("onElementEnd "+elementName);
//		console.log("currentTU["+mid+"]: "+JSON.stringify(currentTU));
		switch(elementName){
			case "mrk":		
//							console.log("currentTU["+mid+"]: "+JSON.stringify(currentTU));
							if(segType=="src"){
								
								currentTU.segments.push({src : currentSegment});
							}else if(segType=="trg"){
								currentSegment.state=state;
								for(let i=0; i<currentTU.segments[mid]["src"].tags.length; i++){
									for(let j=0; j<currentSegment.tags.length; j++){
										if( currentTU.segments[mid]["src"].tags[i].id===currentSegment.tags[j].id &&
											currentTU.segments[mid]["src"].tags[i].name===currentSegment.tags[j].name &&
											currentTU.segments[mid]["src"].tags[i].type===currentSegment.tags[j].type){
												currentSegment.tags[j].code=currentTU.segments[mid]["src"].tags[i].code;
											}
									}
								}
								currentTU.segments[mid][segType]=currentSegment;
							}else{
								currentTU.segments[mid][segType]=currentSegment;
							}
//							console.log("currentTU["+mid+"]: "+JSON.stringify(currentTU));
							inSegment=false; 											break;
							
			case "target":	if(inAltTrans){
								currentSegment.matchQuality=matchQuality;
								if(typeof currentTU.segments[mid]!= "undefined"){
									currentTU.segments[mid][segType]=currentSegment;
								}
								inSegment=false;
								matchQuality=0;
							}																break;
			case "source":	if(inAltTrans){
								if(typeof currentTU.segments[mid]!= "undefined"){
									currentTU.segments[mid]["tmxSrc"]=currentSegment;
								}
								inSegment=false;
							}																break;
			case "alt-trans":	inAltTrans=false;											break;
			case "trans-unit":	TUs.push(currentTU);
																							break;
			case "g":
				if(inSegment){
					currentSegment.tags.push(new Tag(elementName, "CLOSE", tagIds.pop(), currentSegment.text.length, currentSegment.tags.length, currentSegment.tags.length));
				}
		}
	};
	
	parser.onText = function(getText) {
		const text = getText();
		
		if(newSegment && inSegment){
			currentSegment.text=decodeHtmlEntities(text)
			trimInicial(currentSegment);
			newSegment=false;
		}else if(inSegment){
			currentSegment.text+=decodeHtmlEntities(text);
		}
	};
	
	parser.parse(xliff);
//	console.log("Parse complete.");
	return TUs;
}

function pintaTag(tag){
	let textTag="";
	switch(tag.type){
		case "OPEN":
			textTag='<'+tag.name+' id="'+tag.id+'">';
		break;
		case "CLOSE":
			textTag='</'+tag.name+'>';
		break;
		case "ALONE":
			textTag='<'+tag.name+' id="'+tag.id+'"/>';
		break;
	}
	return textTag;
}

function generaTextTraduit(segment){
	let textFinal="";
	let iText=0;
	//segment=encodeHtmlEntities(segment);
	while(iText<segment.text.length){
		for(let iTag=0; iTag<segment.tags.length; iTag++){
			if(segment.tags[iTag].position==iText){
				textFinal+=pintaTag(segment.tags[iTag]);
			}
		}
		textFinal+=encodeHtmlEntities(segment.text.charAt(iText));
		iText++;
	}
	//tags del final
	for(let iTag=0; iTag<segment.tags.length; iTag++){
		if(segment.tags[iTag].position==iText){
			textFinal+=pintaTag(segment.tags[iTag]);
		}
	}
	return segment.trimI+textFinal;
}

function matchSubstituition(TUs){
	console.log("matchSubstituition");
	let iTu=0;
	let traduit=false;
	while(iTu<TUs.length && !traduit){
		let iSeg=0;
		while(iSeg<TUs[iTu].segments.length && !traduit){
			if(TUs[iTu].segments[iSeg]["trg"].text !== TUs[iTu].segments[iSeg]["src"].text
				&& (typeof(TUs[iTu].segments[iSeg]["trg"].state)!==undefined && TUs[iTu].segments[iSeg]["trg"].state!==("blocked"))){
				traduit=true;
			}
			iSeg++;
		}
		iTu++;
	}
	if(!traduit){
		TUs.forEach(function(tu) {
			tu.segments.forEach(function(seg) {
				if( (seg["trg"].text == seg["src"].text) &&  (typeof(seg["trg"].state)!==undefined && seg["trg"].state!==("blocked")) ){
					if( typeof(seg["ECL TMX"])!=='undefined' ){
						console.log("ECL TMX");
						seg["trg"].text = seg["ECL TMX"].text;
						for(let i=0; i<seg["trg"].tags.length; ++i){
							//console.log(i);
							if(i<seg["ECL TMX"].tags.length){
								//console.log(i+": mou");
								seg["trg"].tags[i].position = seg["ECL TMX"].tags[i].position;
							}
						}
						//Posa tags de principi igual que a ["src"]
						//if(seg["trg"].tags.length===seg["src"].tags.length && seg["src"].tags[0].position===0 && seg["trg"].tags[0].position===seg["trg"].text.length){
						if(seg["src"].tags.length>0 && seg["trg"].tags.length===seg["src"].tags.length && seg["src"].tags[0].position===0 && seg["trg"].tags[0].position===seg["trg"].text.length){
							seg["trg"].tags[0].position=0;
						}
					}else if(typeof(seg["ECL_Repetition"])!=='undefined'){
						console.log("ECL_Repetition");
						seg["trg"].text = seg["ECL_Repetition"].text;
						for(let i=0; i<seg["trg"].tags.length; ++i){
							//console.log(i);
							if(i<seg["ECL_Repetition"].tags.length){
								//console.log(i+": mou");
								seg["trg"].tags[i].position = seg["ECL_Repetition"].tags[i].position;
							}
						}
					}else if(typeof(seg["ECL TA"])!=='undefined'){
						console.log("ECL TA");
						seg["trg"].text = seg["ECL TA"].text;
						for(let i=0; i<seg["trg"].tags.length; ++i){
							//console.log(i);
							if(i<seg["ECL TA"].tags.length){
								//console.log(i+": mou");
								seg["trg"].tags[i].position = seg["ECL TA"].tags[i].position;
							}
						}
					}
				}
			});
		});
	}
	console.log(TUs);
	return TUs;
}

function setDistance(TUs){
	for(let iTU=0; iTU<TUs.length; ++iTU){
		for(let iSeg=0; iSeg<TUs[iTU].segments.length; ++iSeg){
			if(typeof(TUs[iTU].segments[iSeg]['ECL TMX']) !== 'undefined' && typeof(TUs[iTU].segments[iSeg]['tmxSrc']) !== 'undefined'){
				let srcText = numberSubstituition(TUs[iTU].segments[iSeg]['src'].text, TUs[iTU].segments[iSeg]['tmxSrc'].text);
				//console.log("calcula distancia: "+iTU+":"+iSeg);
				TUs[iTU].segments[iSeg]['ECL TMX'].distance=levenshtein(srcText, TUs[iTU].segments[iSeg]['tmxSrc'].text)
			}
		}
	}
}

// Substitueix numeros per X, igual que a la memoria
function numberSubstituition(src, tmxSrc){
	//console.log("numberSubstituition: ("+src+","+tmxSrc+")");
	//let regexSrc = new RegExp('(^| )([0-9]+(?:\.|,)?[0-9]*)($| )', 'gd');
	//return src.replace(regexSrc, '$1X$3');
	let regexSrc = new RegExp('([0-9]+[.,]?[0-9]*)', 'gd');
	return src.replace(regexSrc, 'X');



	//let regexTmxSrc = new RegExp('(?:^| )X(?:$| )', 'gd'); //(^|\s) would match space or start of string and ($|\s) for space or end of string, (?:...) per no capturar el grup
	//let substituition = src;
	//
	//var srcNums = [];
	//var tmxSrcNums = [];
	//var temp;
	//while ((temp = regexSrc.exec(src)) !== null) {
	//	console.log(temp);
	//	console.log("srcNums < "+temp[0]+","+temp['index']);
	//	srcNums.push({valor: temp[0], index: temp['index']});
	//}
	//////console.log(regexTmxSrc.exec(tmxSrc));
	////while ((temp = regexTmxSrc.exec(tmxSrc)) !== null) {
	////	console.log(temp);
	////	console.log("tmxSrcNums < "+temp[0]+","+temp['index']);
	////	tmxSrcNums.push({valor: temp[0], index: temp['index']});
	////}
}

function levenshtein(a, b){
	var n = a.length;
	var m = b.length;
//	console.log("src    a: ["+n+"]["+a+"]");
//	console.log("tmxSrc b: ["+m+"]["+b+"]");
	// matriz de cambios mínimos
	var d = [];
	
	if(n == 0) 
		return m;
	if(m == 0)
		return n;
	// inicializamos el peor caso (insertar todas)
	let i=0;
	let j=0;
	for(i = 0; i <= n; i++){
		(d[i] = [])[0] = i;
	}
	for(j = 0; j <= m; j++){
		d[0][j] = j;
	}
	// cada elemento de la matriz será la transición con menor coste
	let I=0;
	let J=0;
	for(i = 1, I = 0; i <= n; i++, I++){
		for(j = 1, J = 0; j <= m; j++, J++){
			if(b[J] == a[I]){
				d[i][j] = d[I][J];
			}else{
				d[i][j] = Math.min(d[I][j], d[i][J], d[I][J]) + 1;
			}
		}
	}
	
//	let taula ="   |    |  ";
//	for(j = 0; j < m; j++){
//		taula = taula+b[j]+" |  ";
//	}
//	taula = taula+"\n";
//	for(i = 0; i <= n; i++){
//		if(i>0){
//			taula = taula + " "+a[i-1];
//		}else{
//			taula = taula + "  ";
//		}
//		for(j = 0; j <= m; j++){
//			taula = taula+" | "+d[i][j].toString().padStart(2,"0");
//		}
//		taula = taula+" |\n";
//	}
//	console.log(taula);
	
	i=n;
	j=m;
	I=i-1;
	J=j-1;
	let operations = [];
	// CERCA DE DRETA A ESQUERRA
	while(i>0 && j>0){
		if( (d[I][J]<=d[i][J]) && (d[I][J]<=d[I][j]) && (d[I][J]==d[i][j]) ){
			operations.push({operation:"COPY", value:a.charAt(I)});
			i--; j--;
		}else if( (d[I][J]<=d[i][J]) && (d[I][J]<=d[I][j]) ){
			operations.push({operation:"REPLACE", value:a.charAt(I), src:b.charAt(J)});
			i--; j--;
		}else if(  (d[I][j]<=d[i][J]) ){
			operations.push({operation:"INSERT", value:a.charAt(I)});
			//operations.push({operation:"DELETE", value:"", src:b.charAt(J)});
			i--;
		}else{
			//operations.push({operation:"INSERT", value:a.charAt(I)});
			operations.push({operation:"DELETE", value:"", src:b.charAt(J)});
			j--;
		}
//		console.log(operations[operations.length-1]);
		I=i-1;
		J=j-1;
	}
	while(i>0){
		operations.push({operation:"INSERT", value:a.charAt(I)});
//		console.log(operations[operations.length-1]);
		i--;
		I=i-1;
	}
	while(j>0){
		operations.push({operation:"DELETE", value:"", src:b.charAt(J)});
//		console.log(operations[operations.length-1]);
		j--;
		J=j-1;
	}
	
//	console.log({distance: d[n][m], operations: operations});
	return {distance: d[n][m], operations: operations.reverse()};
}

function searchRepetitions(TUs){
//	console.log("searchRepetitions");
	let repetitions_targets = Array();
	let repetitions_sources = Array();
	for(let iTU=0; iTU<TUs.length; ++iTU){
		for(let iSeg=0; iSeg<TUs[iTU].segments.length; ++iSeg){
			for(let i=iTU; i<TUs.length; ++i){
				let inici = (iTU===i) ? (iSeg+1) : 0;			// En el mateix TU busquema partir del segment actual
				for(let j=inici; j<TUs[i].segments.length; ++j){
					if(TUs[iTU].segments[iSeg]["src"].text==TUs[i].segments[j]["src"].text){
						//Repericio
						if(typeof(repetitions_targets[iTU])==='undefined'){
							repetitions_targets[iTU]=Array()
						}
						if(typeof(repetitions_targets[iTU][iSeg])==='undefined'){
							repetitions_targets[iTU][iSeg]=Array()
						}
						if(typeof(repetitions_sources[i])==='undefined'){
							repetitions_sources[i]=Array()
						}
						repetitions_targets[iTU][iSeg].push({tu:i, seg:j});
						repetitions_sources[i][j]={tu:iTU, seg:iSeg};
					}
				}
			}
		}
	}
	//console.log("repetitions: "+JSON.stringify({repetitions_targets: repetitions_targets, repetitions_sources: repetitions_sources}));
	return {target: repetitions_targets, source: repetitions_sources};
}

async function comprovaTags(TUs, pois, orderId){
	pois.forEach(poi => {if(poi.name=="TAG"){this.deleteEditorPoi(poi.id)}});
	for(let iTU=0; iTU<TUs.length; ++iTU){
		for(let iSeg=0; iSeg<TUs[iTU].segments.length; ++iSeg){
			if( TUs[iTU].segments[iSeg].src.text.trim().length===0 && (TUs[iTU].segments[iSeg].src.text!=TUs[iTU].segments[iSeg].trg.text)){
				//(TUs[iTU].segments[iSeg].src.tags.length>0) && (TUs[iTU].segments[iSeg].src.tags[0].pos===0)){
				// HI POT HAVER CONTINGUT FORA DEL TAG: >....<x id=1>
				await this.addEditorPoi(orderId, "TAG", "TAG", iTU, iSeg);
			}else if(TUs[iTU].segments[iSeg].src.tags.length!=TUs[iTU].segments[iSeg].trg.tags.length){
				// DIFERENT NUMERO DE TAGS
				await this.addEditorPoi(orderId, "TAG", "TAG", iTU, iSeg);
			}else{
				// TAGS DESORDENATS
				let trobat=false;
				for(let iTag = 0; iTag < TUs[iTU].segments[iSeg].src.tags.length ; iTag++){
					if((TUs[iTU].segments[iSeg].src.tags[iTag].id !== TUs[iTU].segments[iSeg].trg.tags[iTag].id ||
						TUs[iTU].segments[iSeg].src.tags[iTag].name !== TUs[iTU].segments[iSeg].trg.tags[iTag].name ||
						TUs[iTU].segments[iSeg].src.tags[iTag].type !== TUs[iTU].segments[iSeg].trg.tags[iTag].type) &&
						!trobat)
					{
						trobat=true;
						console.log("TAG");
						//m = "TAG ";
						if(TUs[iTU].segments[iSeg].src.tags[iTag].id !== TUs[iTU].segments[iSeg].trg.tags[iTag].id){
							//m = m+" id ["+TUs[iTU].segments[iSeg].src.tags[iTag].id+","+TUs[iTU].segments[iSeg].trg.tags[iTag].id+"]";
							console.log("id ["+TUs[iTU].segments[iSeg].src.tags[iTag].id+","+TUs[iTU].segments[iSeg].trg.tags[iTag].id+"]");
						}
						if(TUs[iTU].segments[iSeg].src.tags[iTag].name !== TUs[iTU].segments[iSeg].trg.tags[iTag].name){
							//m = m+" name ["+TUs[iTU].segments[iSeg].src.tags[iTag].name+","+TUs[iTU].segments[iSeg].trg.tags[iTag].name+"]";
							console.log("id ["+TUs[iTU].segments[iSeg].src.tags[iTag].name+","+TUs[iTU].segments[iSeg].trg.tags[iTag].name+"]");
						}
						if(TUs[iTU].segments[iSeg].src.tags[iTag].type !== TUs[iTU].segments[iSeg].trg.tags[iTag].type){
							//m = m+" type ["+TUs[iTU].segments[iSeg].src.tags[iTag].type+","+TUs[iTU].segments[iSeg].trg.tags[iTag].type+"]";
							console.log("id ["+TUs[iTU].segments[iSeg].src.tags[iTag].type+","+TUs[iTU].segments[iSeg].trg.tags[iTag].type+"]");
						}
						//console.log(m);
						await this.addEditorPoi(orderId, "TAG", "TAG", iTU, iSeg);
					}
				}
			}
		}
	}
	return 1;
	//console.log(tagsSospitosos);
}

function calculaProgres(TUs){
	let paraules=0;
	let traduides=0;
	
	for(let iTU=0; iTU<TUs.length; ++iTU){
		for(let iSeg=0; iSeg<TUs[iTU].segments.length; ++iSeg){
			let count = TUs[iTU].segments[iSeg]["src"].text.length;
			paraules += count;
			//if(((typeof(TUs[iTU].segments[iSeg]["src"].state)!==undefined) &&(TUs[iTU].segments[iSeg]["src"].state!=="new")) || (TUs[iTU].segments[iSeg]["src"].text===TUs[iTU].segments[iSeg]["trg"].text)){
			if((typeof(TUs[iTU].segments[iSeg]["trg"].state)!==undefined) && (TUs[iTU].segments[iSeg]["trg"].state!=="new")){
				traduides+=count;
			}
		}
	}
	//console.log("paraules: "+paraules)
	//console.log("traduides: "+traduides);
	//console.log("progres: "+Math.round((traduides/paraules)*100));
	return Math.round((traduides/paraules)*100);
}

function encodeHtmlEntities(caracter){
	if(caracter=='&'){
		return '&amp;';
	}else if(caracter=='<'){
		return '&lt;'
	}else if(caracter=='>'){
		return '&gt;'
	}else{
		return caracter;
	}
}

function regeneraXliffPomise(xliff, TUs){
	const p = (xliff, TUs) => new Promise((resolve, reject) => { 
		regeneraXliff(xliff, TUs);
	});
	return async ()=>{
		let a = await p(xliff, TUs);
		return a;
	}
}
function regeneraXliff(xliff, TUs){
//	console.log("regeneraXliff xliff: "+xliff);
//	console.log("regeneraXliff TUs: "+JSON.stringify(TUs));
	let index=0;
	let indexCopiat=0
	let xliffTraduit="";
	for(let iTu=0; iTu<TUs.length; iTu++){
//		console.log("iTu: "+iTu);
		index=xliff.indexOf('<trans-unit ', index);
		index=xliff.indexOf('<target ', index);
		for(let iSeg=0; iSeg<TUs[iTu]["segments"].length; iSeg++){
//			console.log("iTu,iSeg: ("+iTu+","+iSeg+")");
			index=xliff.indexOf('<mrk ', index);
//			console.log("index: "+index);
			// Hem de modificar l'esquelet per afegir l'estat, lo seguent ja no val
			//	index=xliff.indexOf('>', index)+1;
			// i hem de generar a ma els atributs de l'mrk
			let mrk='<mrk mid="'+iSeg+'" mtype="seg" state="'+TUs[iTu]["segments"][iSeg]["trg"]["state"]+'">';
			let fiTag=xliff.indexOf('>', index);
			let fi=fiTag;
			if(xliff.charAt(fiTag-1)==="/"){
//				console.log("mrk buit!");
				xliffTraduit+=xliff.substring(indexCopiat,fiTag+1);
			}else{
				fi=xliff.indexOf('</mrk>', fiTag);
				xliffTraduit+=xliff.substring(indexCopiat,index)+mrk+generaTextTraduit(TUs[iTu]["segments"][iSeg]["trg"]);
			}
//			console.log("segment["+iTu+","+iSeg+"]: ["+xliff.substring(index,fi)+"]");
			index=indexCopiat=fi;
		}
	}
	xliffTraduit+=xliff.substring(indexCopiat);
	//console.log("XLIFF regenerated: "+xliffTraduit);
	return xliffTraduit;
}	
//-------------------------------------------------------------------------
//		[ XPATH ]
//-------------------------------------------------------------------------
//	let parser = new DOMParser();
//	console.log("xliff: "+xliff);
//	let doc = parser.parseFromString(xliff, "text/xml");
//	console.log("doc: "+JSON.stringify(doc));
//	for(let iTu=0; iTu<TUs.length; iTu++){
//		for(let iSeg=0; iSeg<TUs[iTu]["segments"].length; iSeg++){
//			let expr = "//trans-unit[@id='"+TUs[iTu].idTu+"']/target/mrk[@mid='"+iSeg+"']"
////			console.log("expr: "+expr);
//			let seg = doc.evaluate(expr, doc, nsResolver, XPathResult.UNORDERED_NODE_SNAPSHOT_TYPE, null);
//			console.log(seg);
//			let node = seg.snapshotItem(0);
//			console.log(node);
//		}
//	}


function spellCheck(language, TUs){
//	console.log("spellCheck TUs: "+JSON.stringify(TUs));
	var doc='{"annotation":[';
	for(let iTu=0; iTu<TUs.length; iTu++){
		if(iTu>0) doc += ',';
		let iSeg=0;
		for(iSeg=0; iSeg<TUs[iTu]["segments"].length; iSeg++){
			if(iSeg>0) doc += ',';
			doc += '{"text": "'+TUs[iTu]["segments"][iSeg]["trg"].text.replace(/"/g,'\\"')+'"}';
			doc += ',{"markup": "</b>", "interpretAs": "\\n"}';
		}
		if(iSeg>0) doc += ',';
		doc += '{"markup": "</b>", "interpretAs": "\\n\\n"}';
	}
	doc += ']}';
		
	let config = {
		headers: {
		  'Content-type': "application/x-www-form-urlencoded",
		  'Accept': "application/json"
		},
		params: {
		}
	}
	
	let formData = new FormData();
	formData.append('language', language);
	formData.append('data', doc);
//	console.log("formData");
//	console.log(formData);
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/spellcheck", formData, config);
}

function parseSpellCheckResp(TUs, matches){
	//console.log("parseSpellCheckResp");
	
	function spellError(iTu, iSeg, offset, length, message, shortMessage, replacements){
		this.iTu=iTu
		this.iSeg=iSeg;
		this.offset=offset
		this.length=length;
		this.message=message
		this.shortMessage=shortMessage;
		this.replacements=replacements;
	};
	let iMatch=0;
	let gOffset=0;
	let errorsList = Array();
	for(let iTu=0; iTu<TUs.length; iTu++){
		if(iMatch<matches.length){
			for(let iSeg=0; iSeg<TUs[iTu]["segments"].length; iSeg++){
//				console.log(" >iSeg: "+iSeg+"[gOffset: "+gOffset+" , ltools offset: "+matches[iMatch].offset+"]");
				var endOffset = gOffset + TUs[iTu]["segments"][iSeg]["trg"].text.length;
				while(iMatch<matches.length && matches[iMatch].offset>=gOffset && matches[iMatch].offset<endOffset){
					if(TUs[iTu]["segments"][iSeg]["trg"]["state"]!=="blocked"){
						errorsList.push(new spellError(iTu, iSeg, matches[iMatch].offset-gOffset, matches[iMatch].length, matches[iMatch].message ,matches[iMatch].shortMessage ,matches[iMatch].replacements));
					}
					iMatch++;
				}
				gOffset=endOffset+4;
			}
			gOffset+=4;
		}
	}
	//console.log(errorsList)
	return errorsList;
}

function getGlossary(customerId, langPairId){
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/glossary/"+customerId+"/"+langPairId+"/content", {params: {}});
}

function parseGlossary(glossary){
	let arr = glossary.split("\n");
	let map = {};
	for (var i = 0; i < arr.length; i++){
		let line = arr[i].split("#@#");
		if(line.length===2){
			if(map.hasOwnProperty(line[0])){
				let arr2 = map[line[0]];
				arr2.push(line[1].trim());
				map[line[0]]=arr2;
			}else{
				map[line[0]]=new Array(line[1].trim());
			}
		}
	}
	return map;
}

function recomptaParaules(TUs, repetitions){
//	console.log("recomptaParaules");
//	console.log(TUs);
//	console.log(repetitions);
	
	let count = { noves: 0, rep: 0, m100: 0, m75: 0 }
	
	for(let iTU=0; iTU<TUs.length; ++iTU){
		for(let iSeg=0; iSeg<TUs[iTU].segments.length; ++iSeg){
//			console.log(iTU+","+iSeg);
			count = updateWordCount(count, TUs[iTU].segments[iSeg], repetitions, iTU, iSeg)
		}
	}
	return count;
}

function updateWordCount(translatedWords, segment, repetitions, iTU, iSeg){
//	console.log("updateWordCount");
	if(typeof(segment["trg"].state) !== 'undefined' && segment["trg"].state==='translated' ){
//		console.log("translated");
		let segCount = segment["src"].text.split(/\s+/).length;
//		console.log(segCount);
		if(typeof(segment["ECL TMX"]) !== 'undefined'){
//			console.log("TMX");
			if(segment["ECL TMX"].matchQuality==="100"){
//				console.log("M100");
				translatedWords.m100+=segCount;
			}else{
//				console.log("M75");
				translatedWords.m75+=segCount;
			}
		}else if((typeof(repetitions["source"])!=='undefined') && (typeof(repetitions["source"][iTU])!=='undefined') && (typeof(repetitions["source"][iTU][iSeg])!=='undefined')){
//			console.log("repetition");
			translatedWords.rep+=segCount;
		}else{
//			console.log("new words");
			translatedWords.noves+=segCount;
		}
	}
//	console.log(translatedWords);
	return translatedWords;
}

//function parseGlossary(glossary){
//	var arr = glossary.split("\n");
//	var map = new Map([]);
//	map.clear();
//	console.log(map);
//	for (var i = 0; i < arr.length; i++){
//		let line = arr[i].split("#@#");
//		console.log(i);
//		console.log(line);
//		if(line.length===2){
//			if(map.has(line[0])){
//				console.log("a");
//				map.set(line[0], map.get(line[0]).push(line[1]));
//			}else{
//				console.log("b");
//				map.set(line[0], new Array(line[1]));
//			}
//		}
//		console.log(map);
//	}
//	console.log(map);
//	return map;
//}